import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    DropdownData,
    InputType,
    ReactiveDropdownCatalogs,
} from '@fitogest/reactive-form-builder/interfaces';
import { FincasModel } from 'src/app/models/form-common/fincas.module';

export interface StockageFormModel {
  id_finca?: string | FincasModel | null;
  fecha?: Date | string | null;
}

/** Form used to generate the stockage sheet from balances. */
export class StockageFormDefinition {
  public readonly formFields: Form<StockageFormModel>;

  constructor(
    private readonly fincaName: string,
    private readonly fincas: DropdownData<FincasModel>
  ) {
    this.formFields = {
      name: 'balances-stockage',
      header: '',
      type: FormType.GENERATION,
      sections: [this.createSection()],
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
      dropdownCatalogs: this.getDropdownCatalogs(),
    };
  }


  private getDropdownCatalogs(): ReactiveDropdownCatalogs {
    return {
      critical: ['id_finca'],
      deferred: [],
      lazy: []
    };
  }

  private createSection(): FormSection<StockageFormModel> {
    return {
      name: '',
      fields: [
        this.fincaField(),
        this.dateField(),
      ],
      width: 12,
      isVisible: true,
      order: 1,
    };
  }

  private fincaField(): FormField<StockageFormModel> {
    return {
      name: 'id_finca',
      label: this.fincaName,
      placeholder: 'TODOS',
      input: {
        type: InputType.DROPDOWN,
        isEditable: true,
        data: this.fincas,
        dropdownConfiguration: { valuePrimaryKey: 'id' },
      },
      width: 6,
      conditions: this.conditions(),
      order: 1,
    };
  }

  private dateField(): FormField<StockageFormModel> {
    return {
      name: 'fecha',
      label: 'Fecha',
      input: {
        type: InputType.CALENDAR,
        isEditable: true,
        calendarConfiguration: {
          calendarView: 'month',
          calendarDateFormat: 'mm/yy',
        },
      },
      width: 6,
      conditions: this.conditions(),
      order: 2,
    };
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
